import { useEffect, useState, useRef } from "react"
import { collection, onSnapshot, query, where, getDoc, doc } from "firebase/firestore"
import { db } from "../firebase/config"

export const useDocument = (c, d) => {
  const [document, setDocument] = useState(null)
  const [error, setError] = useState(null)

  // if we don't use a ref --> infinite loop in useEffect
  // _query is an array and is "different" on every function call

  useEffect(() => {
    let ref = doc(db, c, d)

    const unsub = onSnapshot(ref,(snapshot) => {
      if (snapshot.exists()) {
      setDocument({...snapshot.data(), id: snapshot.id})
    } else {
      setDocument(null)
    }

  })

    return () => unsub()

  }, [c, d])

    return { document  }

  }